import { render, staticRenderFns } from "./IncludeInPresentationToggle.vue?vue&type=template&id=2b2e9010&scoped=true&"
import script from "./IncludeInPresentationToggle.vue?vue&type=script&lang=js&"
export * from "./IncludeInPresentationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e9010",
  null
  
)

export default component.exports